// 알림 센터 훅. 기존 useNotes(메모)와 이름 충돌 회피를 위해 suffix `Inbox`.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notificationsApi, type NotificationsQuery } from '../api/notifications';

export const INBOX_KEY = ['notifications', 'inbox'] as const;
export const INBOX_COUNT_KEY = ['notifications', 'unreadCount'] as const;

const POLL_INTERVAL_MS = 30_000;

export function useUnreadCount() {
  return useQuery({
    queryKey: INBOX_COUNT_KEY,
    queryFn: () => notificationsApi.unreadCount().then((r) => r.count),
    refetchInterval: POLL_INTERVAL_MS,
    staleTime: 0,
  });
}

export function useInboxList(query: NotificationsQuery = {}) {
  return useQuery({
    queryKey: [...INBOX_KEY, query],
    queryFn: () => notificationsApi.list(query),
    refetchInterval: POLL_INTERVAL_MS,
  });
}

export function useMarkRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => notificationsApi.markRead(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: INBOX_KEY });
      qc.invalidateQueries({ queryKey: INBOX_COUNT_KEY });
    },
  });
}

export function useMarkAllRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => notificationsApi.markAllRead(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: INBOX_KEY });
      qc.invalidateQueries({ queryKey: INBOX_COUNT_KEY });
    },
  });
}
